/**
 * Created by ptdave on 6/25/17.
 */

import {Pipe, PipeTransform} from '@angular/core';
import {catchError, map, shareReplay} from 'rxjs/operators';
import {DistrictService} from '../../services/district.service';
import {TokenService} from '../../services/token.service';
import {Observable, of} from 'rxjs';
import {DistrictBuildingDto} from '../../models/district/districtBuildingDto';

@Pipe({
  name: 'buildingName'
})
export class BuildingNamePipe implements PipeTransform {
  private cache: Observable<Record<string, string>>;

  constructor(private districtService: DistrictService, private authService: TokenService) {
    this.cache = new Observable<Record<string, string>>();
  }

  transform(value: string, ...args: any[]): Observable<string> | string {
    const token = this.authService.getUserToken();
    if (!this.cache && token) {
      this.cache = this.districtService.getBuildings(token.districtId)
      .pipe(
        map((buildings: DistrictBuildingDto[]) => {
          return buildings.reduce((acc, building) => {
            if (building?.id) {
              acc[building.id] = building.name;
            }
            return acc;
          }, {} as Record<string, string>);
        }),
        shareReplay(1),
        catchError((err) => {
          return of({error: err});
        })
      );
    }
    return this.cache.pipe(
      map((buildingNames: Record<string, string>) => {
        return buildingNames[value] || 'Unknown Building';
      })
    );
  }
}
